export default __webpack_public_path__ + "static/title-gallery-ko-1cd3507663c0a71b1726445ecd74db0d.png";